<template>
  <div id="app">
    <div id="selection">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
body{
    overflow-x:hidden;
}

#app {
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: black;
  padding:15px;
  text-decoration:none;
}

a:hover{
  color:black !important;
}

p{
  font-size:18px;
}


</style>
